/**
 * Type definitions for export state management
 * Defines the state interfaces for each export type
 */

import { format, startOfMonth, subMonths } from 'date-fns'

// Sales Export State
export interface SalesExportState {
  dateFrom: string
  dateTo: string
  includeLineItems: boolean
}

export const defaultSalesExportState: SalesExportState = {
  dateFrom: format(startOfMonth(subMonths(new Date(), 1)), 'yyyy-MM-dd'),  // Start of previous month
  dateTo: format(new Date(), 'yyyy-MM-dd'),
  includeLineItems: false
}

// Products Export State
export interface ProductsExportState {
  productStatus: string
  inventoryFilter: string
  deletedFilter: string
}

export const defaultProductsExportState: ProductsExportState = {
  productStatus: 'all',
  inventoryFilter: 'all',
  deletedFilter: 'exclude'
}

// Future export types can be added here following the same pattern
// Example:
// export interface CustomersExportState {
//   customerType: string
//   region: string
//   status: string
// }

// Union type for all export states (for type safety)
export type ExportState = SalesExportState | ProductsExportState

// Export type identifiers
export const EXPORT_TYPES = {
  LIGHTSPEED_SALES: 'lightspeed_sales',
  LIGHTSPEED_PRODUCTS: 'lightspeed_products',
} as const

export type ExportType = typeof EXPORT_TYPES[keyof typeof EXPORT_TYPES]